import styled from "styled-components";

interface ArticleItemStyleProps {
  $readed?: boolean;
}

export const ArticleItem = styled.li`
  width: 100%;
  padding: 16px;
  background: ${(props) => props.theme.colors.white100};
  box-shadow: ${(props) => props.theme.shadows.box};
  border-radius: 10px;

  &:active {
    background: ${(props) => props.theme.colors.primary8};
    box-shadow: none;
  }

  a {
    gap: 16px;
    color: ${(props) => props.theme.colors.black100};
    display: flex;
    text-decoration: none;
    flex-direction: column;
  }
`;

export const ArticleTit = styled.div<ArticleItemStyleProps>`
  gap: 6px;
  display: flex;
  flex-direction: column;

  span {
    color: ${(props) => props.theme.colors.primary100};
    display: flex;
    font-size: 1.3rem;
    font-weight: 700;
    align-items: center;
    justify-content: space-between;

    span {
      color: ${(props) =>
        props.$readed ? props.theme.colors.black38 : props.theme.colors.red100};
      font-size: 1.2rem;
      font-weight: 400;
    }
  }

  div {
    color: ${(props) => props.theme.colors.text4};
    overflow: hidden;
    font-size: 1.6rem;
    line-height: 150%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const ArticleDate = styled.span`
  color: ${(props) => props.theme.colors.inputPlaceholder};
  font-size: 1.2rem;
  text-align: right;
`;
